import { ASSIGNEE_TYPE, ELECTRONIC_DOCUMENT_STATUS } from '../../../../../constants'
import utils from '../../../../../utils'
import { SIGN_STEP_KEYS } from '../canvasDocConstants'

const SIGN_STEP_DEFINITIONS = [
  {
    step: 1,
    assigneeType: ASSIGNEE_TYPE.LEADER_APPROVER,
    label: 'Ký số',
    signStep: SIGN_STEP_KEYS.LEADER_SIGN,
    historyAction: ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL,
    isSigned: file => file.leader_signed || file.leaderSigned || false,
  },
  {
    step: 3,
    assigneeType: ASSIGNEE_TYPE.LEAD_KTAT_OFFICE,
    label: 'Ký số',
    signStep: SIGN_STEP_KEYS.LEAD_KTAT_SIGN,
    historyAction: ELECTRONIC_DOCUMENT_STATUS.KTAT_OFFICE_APPROVAL,
    isSigned: file => file.lead_ktat_signed || file.leadKtatSigned || false,
  },
  {
    step: 4,
    assigneeType: ASSIGNEE_TYPE.BOARD_OF_DIRECTOR,
    label: 'Ký số',
    signStep: SIGN_STEP_KEYS.BOD_SIGN,
    historyAction: ELECTRONIC_DOCUMENT_STATUS.LEAD_KTAT_OFFICE_APPROVAL,
    isSigned: file => file.bod_signed || file.bodSigned || false,
  },
  {
    step: 5,
    assigneeType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
    label: 'Ký số',
    signStep: SIGN_STEP_KEYS.DIGITAL_SIGN,
    historyAction: ELECTRONIC_DOCUMENT_STATUS.BOARD_OF_DIRECTOR_APPROVAL,
    isSigned: file => file.digital_signed || file.digitalSigned || false,
  },
]

export const resolveActiveSignConfig = ({
  currentStep,
  isAssigneeOfStep,
  afterSignHandlers,
}) => {
  const definition = SIGN_STEP_DEFINITIONS.find(
    item =>
      item.step === currentStep && isAssigneeOfStep(item.assigneeType)
  )

  if (!definition) return null

  return {
    label: definition.label,
    signStep: definition.signStep,
    historyAction: definition.historyAction,
    isSigned: definition.isSigned,
    afterSign: afterSignHandlers[definition.signStep],
  }
}

export const getSignRequirementForStep = step =>
  SIGN_STEP_DEFINITIONS.find(item => item.step === step) || null

export const countUnsignedPdfFiles = (mainFiles, isSignedFn) =>
  (mainFiles || []).filter(
    file =>
      utils.getExtensionFile(file.file_name) === 'pdf' && !isSignedFn(file)
  ).length

export const areAllPdfFilesSigned = (mainFiles, isSignedFn) =>
  countUnsignedPdfFiles(mainFiles, isSignedFn) === 0
